package com.devi3east.bashbuddy.purchase.domain.models

import kotlinx.serialization.Serializable

@Serializable
enum class PurchaseStatus {
    INITIATED,
    PARTIALLY_PAID,
    PAID,
    CANCELED
}